import { Component, OnInit, ViewEncapsulation, Input, OnChanges } from '@angular/core';

@Component({
  selector: 'app-image-with-placeholder',
  templateUrl: './image-with-placeholder.component.html',
  styleUrls: ['./image-with-placeholder.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ImageWithPlaceholderComponent implements OnInit, OnChanges {

  @Input() wpImage:any;
  @Input() imgClass:any;
  @Input() showImage:boolean = true;

  imageLoaded:boolean = false;

  constructor() { }

  ngOnInit() {
  }

  ngOnChanges(changes){
  }

  public onLoad(){
    this.imageLoaded = true;
    //console.log(this.wpImage);
  }

}



// WEBPACK FOOTER //
// ./src/app/image-with-placeholder/image-with-placeholder.component.ts